const Step = require('app/components/checkout/Step')
const PriceLine = require('app/components/checkout/mixins/PriceLine')
const Trans = require('app/components/trans/Trans')
const env = require("app/services/env")

class Basket extends Step {
  get baseClassName () {
    return super.baseClassName + ' step-basket'
  }

  get title () {
    return <Trans>Indkøbskurv</Trans>
  }

  get itemComponent () {
    // ...
  }

  get items () {
    return this.cart.items
  }

  buildItemProps (item) {
    return item
  }

  renderPrevButton () {
    if (this.cart.items.length === 0) {
      return
    }

    return super.renderPrevButton()
  }

  renderNextButton () {
    if (this.cart.items.length === 0) {
      return
    }

    return super.renderNextButton()
  }

  renderItems () {
    const ItemComponent = this.itemComponent

    return this.items.map(item => {
      const itemId = item.id instanceof Array ? item.id.join('|') : item.id
      const key = `${itemId}@${item.price}`
      const props = this.buildItemProps(item)

      return (
        <ItemComponent
          ref={el => this['item_' + itemId] = el}
          key={key} {...props}
        />
      )
    })
  }

  renderItemList () {
    if (this.cart.items.length === 0) {
      return (
        <div className='item-list empty'><Trans>Du har ikke nogen varer i kurven.</Trans></div>
      )
    }

    return (
      <div className='item-list'>{this.renderItems()}</div>
    )
  }

  renderWidgets () {
    // ...
  }

  renderSubtotalPrice () {
    let currencyCode = env.get('currency.alpha_code');
    return (
      <PriceLine title={translate('Subtotal (:currencyCode)', {currencyCode: currencyCode})} value={this.cart.price.subtotal} />)
  }

  renderExtraPrices () {
    // ...
  }

  renderTotalPrice () {
    return (
      <PriceLine title='Total' value={this.cart.price.total} />
    )
  }

  renderStep () {
    return (
      <div>
        {this.renderItemList()}
        {this.renderSubtotalPrice()}
        {this.renderWidgets()}
        {this.renderExtraPrices()}
        {this.renderTotalPrice()}
      </div>
    )
  }
}

module.exports = Basket
